// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wiQ1","option":"styles_option__3xwz1","selected":"styles_selected__1ZYAV"};